import { MdKeyboardArrowLeft, MdKeyboardArrowRight } from 'react-icons/md';
import { IconButton } from '@ds';
import { DateString } from '@/api/types';
import { ClinicalDataTimeLabel } from './ClinicalDataTimeLabel';

type TimeStepperProps = {
  ocsTime?: DateString;
  timestamp?: DateString;
  timezone: string;
  isFirst?: boolean;
  isLast?: boolean;
  onPrev?: () => void;
  onNext?: () => void;
};

export const TimeStepper = ({ ocsTime, timestamp, timezone, isFirst, isLast, onPrev, onNext }: TimeStepperProps) => {
  if (!timestamp) return <ClinicalDataTimeLabel />;

  return (
    <div className="flex gap-2">
      <IconButton
        variant="filled"
        size="xs"
        disableRipple
        isDisabled={isFirst}
        startContent={<MdKeyboardArrowLeft />}
        onClick={onPrev}
      />

      <ClinicalDataTimeLabel ocsTime={ocsTime} timestamp={timestamp} timezone={timezone} />

      <IconButton
        variant="filled"
        size="xs"
        disableRipple
        isDisabled={isLast}
        startContent={<MdKeyboardArrowRight />}
        onClick={onNext}
      />
    </div>
  );
};
